import { DoctorRepository } from "@/domain/repository/doctor-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UpdatePasswordExpiryDateUsecase {
  constructor(private readonly doctorRepo: DoctorRepository) {}

  async execute(
    doctorUuid: string,
    snUpdatedAt: string,
  ): Promise<SATResult<void, SATError>> {
    return this.doctorRepo.updatePasswordExpiryDate(doctorUuid, snUpdatedAt);
  }
}
